import Vue from 'vue'
import Router from 'vue-router'
import App from '../App'

Vue.use(Router)

export default new Router({
    routes: [
        { path: '/', redirect: '/start' },
        {
            path: '/start',
            name: 'Start',
            component: App,
            meta: {'view': 'start'}
        },
        {
            path: '/teams',
            name: 'Teams',
            component: App,
            meta: {'view': 'teams'}

        },
        {
            path: '/teams/:slug',
            name: 'Teambericht',
            component: App,
            meta: {'view': 'teams'}
        },
        {
            path: '/assistenzhunde/:slug/teams',
            name: 'Hundeteams',
            component: App,
            meta: {'view': 'hunde', filter: true}
        },
        {
            path: '/assistenzhunde/:slug',
            name: 'Hunde',
            component: App,
            meta: {'view': 'hunde'}
        },
        {
            path: '/assistenzhunde',
            name: 'AlleHunde',
            component: App,
            meta: {'view': 'hunde'}
        },
        {
            path: '/news',
            name: 'News',
            component: App,
            meta: {'view': 'news'}
        },
        {
            path: '/news/:slug',
            name: 'JumpToNews',
            component: App,
            meta: {'view': 'news', 'jump': true}
        },
        {
            path: '/events/:slug',
            name: 'JumpToEvent',
            component: App,
            meta: {'view': 'news', 'jump': true}
        },
        {
            path: '/helfen',
            name: 'Helfen1',
            component: App,
            meta: {'view': 'helfen'}
        },
        {
            path: '/helfen/finanziell',
            name: 'Helfen21',
            component: App,
            meta: {'view': 'helfen', 'cat': 'finanziell', 'selector': '#helps'}
        },
        {
            path: '/helfen/materiell',
            name: 'Helfen22',
            component: App,
            meta: {'view': 'helfen', 'cat': 'materiell', 'selector': '#helps'}
        },
        {
            path: '/helfen/:slug',
            name: 'Helfen3',
            component: App,
            meta: {'view': 'helfen', 'selector': '#help'}
        },
        {
            path: '/:slug',
            name: 'Seite',
            component: App,
            meta: {'view': 'seite'}
        },
        {
            path: '/:cat/:slug',
            name: 'Unterseite',
            component: App,
            meta: {'view': 'seite'}
        },

    ],
    mode: process.env.NODE_ENV === 'production' ? 'history' : 'hash',
    scrollBehavior(to, from, savedPosition) {

        if (savedPosition) {

            return savedPosition
        }

        if (to.meta.selector) {

            return {
                selector: to.meta.selector
                , offset: {x: 0, y: 100}
            }
        }
        if (to.meta.jump) {
            console.log(to)
            return {
                selector: chronik
                , offset: {x: 0, y: 100}
            }
        }
        else if (to.hash) {
            // return {
            //
            //     selector: to.hash,
            //     offset:  new Promise((resolve, reject) => {
            //         setTimeout(() => {
            //             resolve({x: 0, y: 50})
            //         }, 5000)
            //     })
            // }

            return {
                selector: to.hash,
                offset: {x: 0, y: 100}
            }
        }
        else {
            return {x: 0, y: 0}
        }
    },

})





// WEBPACK FOOTER //
// ./src/router/index.js